import { DrillGroupWellBase } from './base/drill-group-well-base';

export class DrillGroupWell extends DrillGroupWellBase { }